/**
 * Contains all the code for the Magnific Popup lightboxes on the single
 * estate_property pages.
 */
(function($) {
	var propertyGallery = $('.property-lightbox');
	var propertyGallery2 = $('.property-lightbox-cam');

	// Initalize magnific popup gallery.
	propertyGallery.each( function() {
		$(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			closeOnContentClick: false,
			closeBtnInside: true,
			mainClass: 'mfp-img-mobile',
			image: {
				verticalFit: true,
				titleSrc: null
			},
			gallery: {
				enabled: true,
				tCounter: '<button class="image-actions-button mfp-counter"><i class="fa fa-camera" aria-hidden="true"></i> %curr% / %total%</button><span class="mfp-counter"></span>',
				arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>'
			}
		});
	});

	// Initalize magnific popup gallery.
	propertyGallery2.each( function() {
		$(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			closeOnContentClick: false,
			closeBtnInside: true,
			mainClass: 'mfp-img-mobile',
			image: {
				verticalFit: true,
				titleSrc: null
			},
			gallery: {
				enabled: true,
				tCounter: '<button class="image-actions-button mfp-counter"><i class="fa fa-camera" aria-hidden="true"></i> %curr% / %total%</button><span class="mfp-counter"></span>',
				arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>'
			}
		});
	});

	// Open gallery on button click.
	$('#js-open-gallery').on('click', function() {
		propertyGallery.magnificPopup('open');
	});
	// Open gallery on button click.
	$('#js-open-gallery-tc').on('click', function() {
		propertyGallery2.magnificPopup('open');
	});
})(jQuery);
